export const createTextScrollRevealAnimation = (options = {}) => {
    const config = {
        selector: '.text-reveal--js',
        startOpacity: 0.5,
        endOpacity: 1,
        triggerOffset: 0.82,
        staggerAmount: 0.0035,
        ...options,
    };

    const wrapLetters = (element) => {
        const walkNodes = (node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent;

                if (!text.trim()) return; // Skip empty or whitespace-only text nodes

                const fragment = document.createDocumentFragment();

                for (let char of text) {
                    const span = document.createElement('span');
                    const normalizedChar = char === '\n' || char === '\r' ? ' ' : char;
                    span.textContent = normalizedChar;
                    span.style.opacity = config.startOpacity;
                    span.style.display = 'inline';
                    span.style.wordBreak = 'normal';
                    span.style.transition = 'opacity 0.3s ease';

                    fragment.appendChild(span);
                }
                node.parentNode.replaceChild(fragment, node);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                Array.from(node.childNodes).forEach(walkNodes);
            }
        };

        walkNodes(element);
    };

    const getScrollProgress = (rect, triggerY) => {
        const elementHeight = rect.height;
        const distance = triggerY - rect.top;
        return Math.max(0, distance / (elementHeight * 1.2));
    };

    const animateElement = (element) => {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const spans = element.querySelectorAll('span');

        const triggerPoint = windowHeight * config.triggerOffset;

        // Allow animation even if element is above trigger point (for hide on scroll up)
        if (!spans.length) return;

        const progress = getScrollProgress(rect, triggerPoint);

        spans.forEach((span, index) => {
            const delay = index * config.staggerAmount;
            const letterProgress = progress - delay;

            // Bidirectional reveal/hide:
            // letterProgress >= 0: reveal (show endOpacity)
            // letterProgress < 0: hide (show startOpacity)
            const opacity = letterProgress >= 0 ? config.endOpacity : config.startOpacity;
            span.style.opacity = opacity;
        });
    };

    const handleScroll = (elements) => {
        elements.forEach(animateElement);
    };

    const init = () => {
        const elements = document.querySelectorAll(config.selector);

        if (elements.length === 0) {
            return;
        }

        elements.forEach((el) => {
            wrapLetters(el);
        });

        handleScroll(elements);

        const scrollHandler = () => handleScroll(elements);
        window.addEventListener('scroll', scrollHandler);

        return () => window.removeEventListener('scroll', scrollHandler);
    };

    return init();
};
